<div  *ngIf="visible" class="dialog">
  <div class="modal-header-area">
      <i class="far fa-check-circle fa-2x"></i>
  </div>
  <ng-content></ng-content>
  
	<button *ngIf="closable" (click)="close()" aria-label="Close" class="dialog__close-btn">OK</button>
</div>
<div *ngIf="visible" class="overlay" (click)="close()"></div>
